import highlightWords from "highlight-words";
import map from "lodash/map";
import React from "react";
export default function getHighlighted(sourceText, query) {
    if (!sourceText || !query)
        return sourceText;
    const chunks = highlightWords({
        text: sourceText,
        query,
        matchExactly: true
    });
    return map(chunks, ({ text, match, key }) => match ? (React.createElement("span", { className: "highlight", "data-text": text, key: key },
        React.createElement("span", { className: "invisible" }, text))) : (text));
}
